"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const memoize = (fn) => {
    let cache = undefined;
    const cached = function () {
        if (cache !== undefined)
            cache = fn.call(this);
        return cache;
    };
    return cached;
};
const largeSize = memoize(() => new google.maps.Size(46, 50));
const normalSize = memoize(() => new google.maps.Size(37, 40));
const origin = memoize(() => new google.maps.Point(0, 0));
const largeAnchor = memoize(() => new google.maps.Point(23, 48));
const normalAnchor = memoize(() => new google.maps.Point(18.5, 38));
const getIcon = ({ selected, hovered, highlight, number, }) => {
    var _a;
    const large = selected || hovered;
    const fill = highlight || selected ? `#FFF` : `#0066CC`;
    const stroke = highlight ? `#1A1A1A` : selected ? `#0066CC` : `#FFF`;
    const textFill = stroke;
    return {
        url: `data:image/svg+xml;charset=utf8,` +
            encodeURIComponent(`<svg ${large ? `width="46" height="50"` : `width="37" height="40"`} viewBox="4 0 46 50" fill="none" xmlns="http://www.w3.org/2000/svg"><g viewBox="2.25 -3 45.5 54.77" filter="url(#f)"><path d="M10.787 28.665v-.002c-2.268-2.887-3.537-6.332-3.537-9.955 0-9.153 7.933-16.69 17.75-16.69s17.75 7.537 17.75 16.69c0 3.623-1.269 7.069-3.536 9.955l-.001.002-14.126 18.044-.05.05a.252.252 0 01-.099-.018l-14.15-18.076z" fill="${fill}" stroke="${stroke}" stroke-width="2" />${number
                ? `<text x="25" y="26" text-anchor="middle" text-rendering="geometricPrecision" font-size="18" font-weight="700" font-family="'Helvetica Neue',Arial,sans-serif" fill="${textFill}">${(_a = number === null || number === void 0 ? void 0 : number.toFixed(0)) !== null && _a !== void 0 ? _a : ""}</text>`
                : ""}</g><defs><filter id="f" x="0" y="0" width="51" height="62" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix" /><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" /><feOffset dx="1" dy="1" /><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" /><feBlend in2="BackgroundImageFix" result="shadow" /><feBlend in="SourceGraphic" in2="shadow" result="shape" /></filter></defs></svg>`),
        size: large ? largeSize() : normalSize(),
        origin: origin(),
        anchor: large ? largeAnchor() : normalAnchor(),
    };
};
exports.default = getIcon;
